<template>
    <scheduled-loads :loads="deliveredLoads"
                     @refresh="$emit('refresh')"
                     :company="company"
                     @updateLoad="$emit('updateLoad', $event)"
                     :status="loadStatus.DELIVERED">
    </scheduled-loads>
</template>

<script>
import ScheduledLoads from '@/components/dashboard/simple/ScheduledLoads';
import filterLoads from '@/mixins/filterLoads';
import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import loadsRoutingMixin from '@/mixins/loadsRoutingMixin';

export default {
  name: 'Delivered',
  mixins: [
    filterLoads,
    bookedLoadMixin,
    loadsRoutingMixin,
  ],
  components: {
    ScheduledLoads,
  },
  props: {
    company: {
      type: Object,
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  beforeRouteLeave(to, from, next) {
    // Before leave save id in local storage
    const sectionKey = `${from.name}_bookedLoadId`;
    if (this.bookedLoadId) {
      localStorage.setItem(sectionKey, this.bookedLoadId);
    } else {
      localStorage.removeItem(sectionKey);
    }
    next();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Receiving/Delivered.vue